import jwtDecode from 'jwt-decode'
import { useState } from 'react'
import { Button, Spinner } from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import ReCAPTCHA from 'react-google-recaptcha'
import { useDispatch } from 'react-redux'
import { NavLink, useNavigate } from 'react-router-dom'
import { useGetHeadestsQuery, useLoginMutation } from '../redux/api/authApi'
import { setCredentials } from '../redux/slice/authSlice'
import { HiEye, HiEyeSlash } from 'react-icons/hi2'

const LoginForm = () => {
  const [passwordVisible, setPasswordVisible] = useState(false)
  const [recaptchaToken, setRecaptchaToken] = useState(null)
  const [captchaErr, setcaptchaErr] = useState()
  const [validated, setValidated] = useState(false)
  const [error, setError] = useState(null)
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    remember_me: false,
    headset_name: '',
  })

  const [login, { isLoading: isLoggingIn }] = useLoginMutation()
  const { data: headsetList, isLoading } = useGetHeadestsQuery()

  const navigate = useNavigate()
  const disptach = useDispatch()

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!e.currentTarget.checkValidity()) {
      e.stopPropagation()
      return
    }

    // if (!recaptchaToken) {
    //   setcaptchaErr('Please complete the reCAPTCHA challenge.')
    //   return
    // }

    try {
      const data = await login(formData).unwrap()

      if (data.Status === '403') {
        setError('Plan Expired, Please Renew To Continue')
      }

      if (data.Status === '200') {
        const user = jwtDecode(data.token)
        disptach(
          setCredentials({
            token: data.token,
            user: {
              id: user.user_id,
              name: data.username,
              email: user.email_id,
              phoneNumber: user.phone_number,
              role: user.person_type,
              headsetName: formData.headset_name,
            },
          })
        )

        navigate('/children/add')
      }
    } catch (error) {
      setError(error.message)
    } finally {
      setValidated(true)
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const handleRecaptchaChange = (value) => {
    setRecaptchaToken(value)
    setcaptchaErr()
  }

  return (
    <>
      <Form
        className='login-form-container parent-container mx-auto'
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
        style={{ maxWidth: 500 }}
      >
        <h3>Login</h3>
        <p>Please log in to continue</p>
        <span className='text-danger my-3'>{error}</span>
        <Form.Group controlId='username' className='form-inputs'>
          <Form.Label>Email</Form.Label>
          <Form.Control type='email' placeholder='email' name='username' value={formData.username} onChange={handleChange} required />
          <Form.Control.Feedback type='invalid'>Please enter required field.</Form.Control.Feedback>
        </Form.Group>
        <Form.Group controlId='password' className='form-inputs position-relative'>
          <Form.Label className='d-flex align-items-center justify-content-between'>
            <span>Password</span>
            <NavLink to='/forgot-password' style={{ color: '#6bc3ba' }}>
              Forgot password?
            </NavLink>
          </Form.Label>
          <Form.Control
            type={passwordVisible ? 'text' : 'password'}
            name='password'
            placeholder='****************'
            required
            value={formData.password}
            onChange={handleChange}
            maxLength='30'
          />
          <button type='button' className='password-toggle-btn small bg-transparent' onClick={togglePasswordVisibility}>
            {passwordVisible ? <HiEye size={24} /> : <HiEyeSlash size={24} />}
          </button>
          <Form.Control.Feedback type='invalid'>Please enter required field</Form.Control.Feedback>
        </Form.Group>

        <Form.Group controlId='headset' className='form-inputs'>
          <Form.Label>Headset</Form.Label>
          <Form.Select name='headset_name' value={formData.headset_name} onChange={handleChange} required={true}>
            <option value=''>Select Your Headset</option>
            {headsetList?.map((name) => {
              return (
                <option key={name} value={name}>
                  {name}
                </option>
              )
            })}
          </Form.Select>
          <Form.Control.Feedback type='invalid'>Please enter required field</Form.Control.Feedback>
        </Form.Group>

        {/* <div className='my-4'>
          <ReCAPTCHA sitekey={process.env.REACT_APP_GOOGLE_RECAPCHA} onChange={handleRecaptchaChange} />
          {captchaErr && <p className='text-danger small mt-1'>{captchaErr}</p>}
        </div> */}
        <Button variant='primary' className='common-btn full-btn mt-2' type='submit' disabled={isLoggingIn}>
          {isLoggingIn ? (
            <div className='d-flex align-items-center justify-content-center gap-2'>
              <Spinner animation='border' />
              Logging you in
            </div>
          ) : (
            'Continue'
          )}
        </Button>
      </Form>
    </>
  )
}
export default LoginForm
